module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("61NLH"))).then(() => parcelRequire('8rm4T'));